"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _merge2 = _interopRequireDefault(require("lodash/merge"));

var _Client = _interopRequireDefault(require("../Client"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Annotation class to hold all properties and methods related to a single annotation.
 */
var Annotation =
/**
 * Constructor
 *
 * @param {Object} data Annotation object returned from the RedHawk API.
 */
function Annotation() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, Annotation);

  this['@context'] = data['@context'];
  this.type = data.type;
  this.id = data.id;
  this.bodyValue = data.bodyValue;
  this.motivation = data.motivation;
  this.target = data.target;
  this.creator = data.creator;
  this.created = data.created;
  this.modified = data.modified;
  this.status = data.status;
  this.etag = data.etag;
  this.mentions = data.mentions;

  if (data.url) {
    this.url = data.url;
  }

  if (this.motivation !== 'replying') {
    if (_Client["default"].instance.validNodes && _Client["default"].instance.validNodes.length) {
      var curNodeId = (0, _get2["default"])(this, 'target.selector.node.id');
      var curNodeIndex = (0, _get2["default"])(this, 'target.selector.node.index');

      if (curNodeId === undefined && curNodeIndex === undefined) {
        var nodeObj = {
          clientAddedNode: true
        };

        if (_Client["default"].instance.useNodeIndex) {
          nodeObj.index = 0;
        } else {
          nodeObj.id = (0, _get2["default"])(_Client["default"], 'instance.validNodes[0].id');
        }

        this.target = (0, _merge2["default"])(this.target, {
          selector: {
            node: nodeObj,
            subtype: 'node',
            type: 'AdobeAnnoSelector'
          }
        });
      }
    }

    if ((0, _get2["default"])(this.target, 'selector.node.index') !== undefined) {
      this.target.selector.node.id = (0, _get2["default"])(this.target, 'selector.node.index');
      this.target.selector.node.clientAdjustedIndexToId = true;
    }

    if (this.target && this.target.selector && this.target.selector.refinedBy) {
      this.target.selector.noteX = this.target.selector.refinedBy.leftOffset;
      this.target.selector.noteY = this.target.selector.refinedBy.topOffset;
      this.target.selector.sectionId = this.target.selector.refinedBy.startStructId;
      delete this.target.selector.refinedBy;
    }

    if (this.target && this.target.selector && this.target.selector.subtype === 'shape') {
      var inkList = [];
      this.target.selector.inkList.forEach(function (curShape) {
        if (curShape.length) {
          var shapeInkList = [];

          for (var count = 0; count < curShape.length; count += 2) {
            shapeInkList.push({
              x: curShape[count],
              y: curShape[count + 1]
            });
          }

          inkList.push(shapeInkList);
        }
      });
      this.target.selector.inkList = inkList;
    } else if (this.target && this.target.selector && (this.target.selector.subtype === 'highlight' || this.target.selector.subtype === 'replace' || this.target.selector.subtype === 'strikeout')) {
      var quadPoints = this.target.selector.quadPoints;
      var quadInkList = [];

      if (quadPoints && quadPoints.length) {
        for (var count = 0; count < quadPoints.length; count += 8) {
          var _inkList = [];

          _inkList.push({
            x: quadPoints[count],
            y: quadPoints[count + 1]
          });

          _inkList.push({
            x: quadPoints[count + 2],
            y: quadPoints[count + 3]
          });

          _inkList.push({
            x: quadPoints[count + 4],
            y: quadPoints[count + 5]
          });

          _inkList.push({
            x: quadPoints[count + 6],
            y: quadPoints[count + 7]
          });

          quadInkList.push(_inkList);
        }

        this.target.selector.inkList = quadInkList;

        if (this.target.selector.subtype === 'strikeout') {
          this.target.selector.subtype = 'strikethrough';
        }
      }
    }
  }
};
/**
 * Exports the Annotation class.
 */


var _default = Annotation;
exports["default"] = _default;